import { action } from 'typesafe-actions';
import { asyncAction } from 'store/utils/promiseAction';

import {
  DevicesTypes,
  DevicesInterface,
  DeviceStatusInterface,
  DeviceTimelineInterface,
} from './types';

// List Device
export const listDeviceRequest = (payload: object) =>
  action(DevicesTypes.LIST_DEVICE_REQUEST, payload);

export const listDeviceSuccess = (payload: { deviceData: DevicesInterface }) =>
  action(DevicesTypes.LIST_DEVICE_SUCCESS, payload);

export const listDeviceFailure = () => action(DevicesTypes.LIST_DEVICE_FAILURE);

// List Devices
export const listDevicesRequest = (payload: object) =>
  action(DevicesTypes.LIST_DEVICES_REQUEST, payload);

export const listDevicesSuccess = (payload: {
  devicesList: DevicesInterface[];
  totalCount: number;
}) => action(DevicesTypes.LIST_DEVICES_SUCCESS, payload);

export const listDevicesFailure = () =>
  action(DevicesTypes.LIST_DEVICES_FAILURE);

// Devices Update Status
export const updateStatusRequest = (payload: { id: string; status: number }) =>
  action(DevicesTypes.UPDATE_STATUS_REQUEST, payload);

export const updateStatusSuccess = () =>
  action(DevicesTypes.UPDATE_STATUS_SUCCESS);

export const updateStatusFailure = () =>
  action(DevicesTypes.UPDATE_STATUS_FAILURE);

// List Device Status
export const listDeviceStatusRequest = (payload: { body: object }) =>
  asyncAction(DevicesTypes.LIST_DEVICE_STATUS_REQUEST, payload);

export const listDeviceStatusSuccess = (payload: {
  deviceStatus: DeviceStatusInterface;
}) => action(DevicesTypes.LIST_DEVICE_STATUS_SUCCESS, payload);

export const listDeviceStatusFailure = () =>
  action(DevicesTypes.LIST_DEVICE_STATUS_FAILURE);

// List Device Timeline
export const listDeviceTimelineRequest = (payload: { deviceId: string }) =>
  asyncAction(DevicesTypes.LIST_DEVICE_TIMELINE_REQUEST, payload);

export const listDeviceTimelineSuccess = (payload: {
  deviceTimeline: DeviceTimelineInterface[];
}) => action(DevicesTypes.LIST_DEVICE_TIMELINE_SUCCESS, payload);

export const listDeviceTimelineFailure = () =>
  action(DevicesTypes.LIST_DEVICE_TIMELINE_FAILURE);
